<template>
  <div class="bind-account-page">
    <div class="bind-account-card">
      <div class="bind-account-title">微信授权成功</div>
      <div class="bind-account-desc">请绑定已有账号，或直接注册新账号后继续使用。</div>
      <div v-if="wxPending && wxPending.nickname" class="wx-user-row">
        <img v-if="wxPending.avatar" :src="wxPending.avatar" alt="avatar" class="wx-avatar">
        <div class="wx-user-name">{{ wxPending.nickname }}</div>
      </div>
      <van-form @submit="handleBind" class="bind-form">
        <van-field
          v-model="form.account"
          label="账号"
          placeholder="请输入账号/手机号"
          left-icon="user-o"
          :rules="[{ required: true }]"
          input-align="right"
          clearable
        />
        <van-field
          v-model="form.password"
          label="密码"
          type="password"
          placeholder="请输入密码"
          left-icon="lock"
          :rules="[{ required: true }]"
          input-align="right"
          clearable
        />
        <div class="action-area">
          <van-button round block type="info" native-type="submit" class="primary-btn" :loading="loading">
            绑定已有账号
          </van-button>
          <van-button round block plain type="info" class="secondary-btn" :loading="loading" @click="handleRegister">
            微信注册新账号
          </van-button>
          <van-button round block hairline type="default" class="ghost-btn" @click="goLogin">
            返回普通登录
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import useCache from "@/utils/user";
import { bindWxAccount, registerByWx } from "@/api/wxAuth";

export default {
  name: "CreditBindAccount",
  data() {
    return {
      loading: false,
      wxPending: null,
      form: {
        account: "",
        password: "",
      },
    };
  },
  created() {
    this.loadWxPending();
  },
  methods: {
    loadWxPending() {
      const raw = sessionStorage.getItem("wxAuthPending");
      if (!raw) {
        this.wxPending = null;
        Toast("授权信息已失效，请重新进入公众号菜单");
        this.$router.replace({ path: "/credit/login", query: { source: "credit" } });
        return;
      }
      try {
        const data = JSON.parse(raw);
        if (!data || !data.openId) {
          throw new Error("invalid wx pending");
        }
        this.wxPending = data;
      } catch (error) {
        this.wxPending = null;
        sessionStorage.removeItem("wxAuthPending");
        Toast("授权信息已失效，请重新进入公众号菜单");
        this.$router.replace({ path: "/credit/login", query: { source: "credit" } });
      }
    },
    finishAuth(userData, successText) {
      useCache.cacheUserData(userData);
      sessionStorage.removeItem("wxAuthPending");
      Toast(successText);
      this.$router.replace({ path: "/credit/home" });
    },
    handleBind() {
      if (!this.wxPending || !this.wxPending.openId) {
        return;
      }
      this.loading = true;
      bindWxAccount({
        openId: this.wxPending.openId,
        account: this.form.account,
        password: this.form.password,
      }).then((res) => {
        this.finishAuth(res.data.data, "绑定成功");
      }).catch((err) => {
        Toast(err.message);
      }).finally(() => {
        this.loading = false;
      });
    },
    handleRegister() {
      if (!this.wxPending || !this.wxPending.openId) {
        return;
      }
      if (!this.form.account || !this.form.password) {
        Toast("请输入账号和密码");
        return;
      }
      this.loading = true;
      registerByWx({
        openId: this.wxPending.openId,
        unionId: this.wxPending.unionId,
        nickname: this.wxPending.nickname,
        avatar: this.wxPending.avatar,
        inviterId: this.wxPending.inviterId,
        account: this.form.account,
        password: this.form.password,
      }).then((res) => {
        this.finishAuth(res.data.data, "注册成功");
      }).catch((err) => {
        Toast(err.message);
      }).finally(() => {
        this.loading = false;
      });
    },
    goLogin() {
      this.loading = false;
      this.wxPending = null;
      sessionStorage.removeItem("wxAuthPending");
      this.$router.replace({
        path: "/credit/login",
        query: { source: "credit" },
      });
    },
  },
};
</script>

<style scoped>
.bind-account-page {
  min-height: 100vh;
  padding: 24px 16px;
  background: #f0f4ff;
}

.bind-account-card {
  max-width: 520px;
  margin: 56px auto 0;
  background: #fff;
  border-radius: 16px;
  padding: 28px 20px 24px;
  box-shadow: 0 8px 24px rgba(21, 102, 193, 0.12);
}

.bind-account-title {
  font-size: 22px;
  font-weight: 700;
  color: #0d1b3e;
  text-align: center;
}

.bind-account-desc {
  margin-top: 12px;
  text-align: center;
  font-size: 14px;
  line-height: 22px;
  color: #5b6b8a;
}

.wx-user-row {
  margin: 18px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.wx-avatar {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  object-fit: cover;
}

.wx-user-name {
  font-size: 15px;
  font-weight: 600;
  color: #1566c1;
}

.bind-form {
  margin-top: 24px;
}

.action-area {
  padding: 10px 16px 0;
}

.primary-btn {
  margin-top: 18px;
  background: #1566c1;
  border-color: #1566c1;
}

.secondary-btn {
  margin-top: 12px;
  border-color: #1566c1;
  color: #1566c1;
}

.ghost-btn {
  margin-top: 12px;
}
</style>
